import Icon from "@client/controls/Icon/component";
import Modal from "@client/controls/Modal/container";
import { type WithChildren } from "@client/types/WithChildren";
import React from "react";
import "./style.less";

export type MapProps = WithChildren & {
  bodyStyle: React.CSSProperties;
  heading?: any;
  footer?: any;
  isVisible: boolean;
  overlayColor: string;
  style: React.CSSProperties;
  width: string;
};

export type ActionProps = {
  onClose: () => void;
};

export default (props: ActionProps & MapProps) => (
  <Modal
    className="popup"
    isInViewport
    isCentered
    isVisible={props.isVisible}
    onClose={props.onClose}
    overlayColor={props.overlayColor}
    style={props.style}
    width={props.width}
  >
    <Modal.Body style={props.bodyStyle}>
      <Icon className="close" iconClassName="far fa-times" onClick={props.onClose} />

      {props.heading}

      {props.children}

      {props.footer}
    </Modal.Body>
  </Modal>
);
